import { TabNames } from '@enums/TabNames';
import { CustomCellSalespersonComponent } from '@shared/grids/custom-cell-salesperson/custom-cell-salesperson.component';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const BUILDINGS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/buildings-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'name',
        field: 'name',
        headerName: 'Name',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'propertyManagerCompanyName',
        field: 'propertyManagerCompanyName',
        headerName: 'Property Manager',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'addressLines',
        field: 'addressLines',
        headerName: 'Address',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor',
        sortable: false
    },
    {
        colId: 'cityName',
        field: 'cityName',
        headerName: 'City',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'stateName',
        field: 'stateName',
        headerName: 'State',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'countryName',
        field: 'countryName',
        headerName: 'Country',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'buildingSalespersons',
        field: 'buildingSalespersons',
        headerName: 'Salesperson',
        cellRenderer: CustomCellSalespersonComponent
    },
    {
        colId: 'isActive',
        field: 'isActive',
        headerName: 'Condition',
        valueFormatter: (params: any) => {
            return params.value ? 'Active' : 'Archived';
        }
    }
];
